import React from "react";
import "./courseCard.css";
import {Link} from 'react-router-dom';
import {
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button
} from "reactstrap";

const courseCard = props => {
  return (
    <Col
      sm={{ size: `${props.sm}` }}
      lg={{ size: `${props.lg}` }}
      className="pb-5 text-left"
    >
      <Card className="coursepage-course-cards justify-content-center">
        {props.children}
        <CardTitle className="home-course-card-titles pt-3">
          {props.title}
        </CardTitle>
        <CardBody>
          <CardSubtitle className="home-course-card-text">
            {props.description}
          </CardSubtitle>
        </CardBody>
        <Link style={{height:'0px'}} className="middle mx-auto" to={props.path}>
          <Button className="align-self-end text-center view-course-btn1">
            View Course Details
          </Button>
        </Link>
      </Card>
    </Col>
  );
};

export default courseCard;
